import { writable } from 'svelte/store';
const { subscribe, set, update } = writable(null);
export const staticsStore = {
    subscribe,
    set,
    update,
};
